// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Or-z","giftOrPromoSelector":"Pr-z","disabled":"Qr-z","subTitle":"Rr-z","selectShipAddressMessage":"Sr-z","changePayment":"Tr-z"};